import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const BOMList = lazy(() => import('./BOMList'));
const BOMDesigner = lazy(() => import('./BOMDesigner'));
const RoutingsList = lazy(() => import('./RoutingsList'));
const ProductionOrderList = lazy(() => import('./ProductionOrderList'));
const WorkCenterList = lazy(() => import('./WorkCenterList'));
const QCInspections = lazy(() => import('./QCInspections'));

export const manufacturingRoutes = (
    <React.Fragment key="manufacturing">
        <Route element={<ProtectedRoute permission="manufacturing.bom.view" />}>
            <Route path="/manufacturing/boms" element={<BOMList />} />
            <Route path="/manufacturing/boms/new" element={<BOMDesigner />} />
            <Route path="/manufacturing/boms/:id" element={<BOMDesigner />} />
            <Route path="/manufacturing/boms/edit/:id" element={<BOMDesigner />} />
            <Route path="/manufacturing/routings" element={<RoutingsList />} />
        </Route>
        <Route element={<ProtectedRoute permission="manufacturing.production_order.view" />}>
            <Route path="/manufacturing/production-orders" element={<ProductionOrderList />} />
        </Route>
        <Route element={<ProtectedRoute permission="manufacturing.work_center.view" />}>
            <Route path="/manufacturing/work-centers" element={<WorkCenterList />} />
        </Route>
        <Route element={<ProtectedRoute permission="manufacturing.qc.view" />}>
            <Route path="/manufacturing/qc-inspections" element={<QCInspections />} />
        </Route>
    </React.Fragment>
);
